import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getChannelsUrl } from 'config/api';

import {
    getChannels,
    getChannelsFailure,
    getChannelsRequest,
    getChannelsSuccess,
} from 'store/programs/actions';
import { GET_CHANNELS } from 'store/programs/constants';
import { BTVServicesResponse } from 'store/railsBuilder/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';
import isFunction from 'utils/function.ts';

export function* onGetChannels(action?: ReturnType<typeof getChannels>) {
    const autoRetry = action?.meta?.autoRetry;
    const onSuccess = action?.meta?.onSuccess;
    const onFailure = action?.meta?.onFailure;

    try {
        yield put(getChannelsRequest());

        const { data: channelsResponse }: AxiosResponse<BTVServicesResponse> =
            yield call(NagraInstance.get, getChannelsUrl());

        if (!channelsResponse?.services?.length) {
            throw new Error('No channels received from the BE');
        }

        yield put(getChannelsSuccess(channelsResponse));

        if (isFunction(onSuccess)) {
            yield call(onSuccess, channelsResponse);
        }
    } catch (error: any) {
        yield put(getChannelsFailure(error));

        if (isFunction(onFailure)) {
            yield call(onFailure, error);
        }
    }
}

export default [takeLatest(GET_CHANNELS, onGetChannels)];
